import React from 'react';

import PendingConfigImports from '../../components/Admin/PendingConfigImports';

function PendingConfigImportsView() {
  return (
    <PendingConfigImports />
  );
}

export default PendingConfigImportsView;
